/* Package JSON Import will be here */
import React from "react";
import { Typography, Space, Badge, Row, Col } from "antd";
import { useSelector } from "react-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Spinner } from "components/Spinner"
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
/* Const,Let & Var will be here */

const MinOrderQtyInfo = (props) => {
    const { staticContent } = useSelector((state) => ({
        staticContent: state.staticContent
    }));

    const renderComponent = () => {
        if (staticContent.isLoading) {
            return (
                <div className="container pt-5">
                    <Spinner message={props.translate("order.minOrderQty.disclaimer.loading")} />
                </div>
            );
        }
        else if (staticContent.minOrderQtyDisclaimer !== null) {
            return (
                <React.Fragment>
                    {staticContent.minOrderQtyDisclaimer.commonDisclaimerList.map((item, index) => {
                        return (
                            <Row key={index}>
                                <Col span={24}>
                                    <Text type="danger" className="font-12">{item}</Text>
                                </Col>
                            </Row>
                        )
                    })}
                    {staticContent.minOrderQtyDisclaimer.recentPurchaseIndication !== undefined &&
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Badge status="processing" />
                                    <Text type="danger" className="font-12">{staticContent.minOrderQtyDisclaimer.recentPurchaseIndication}</Text>
                                </Space>
                            </Col>
                        </Row>
                    }
                </React.Fragment>
            );
        }
        else {
            return "";
        }
    }

    return (
        renderComponent()
    );
};

export default MinOrderQtyInfo;